import { FeeCreateAPIDataRequest } from "gen/model/feeCreateAPIDataRequest";
import React from "react";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormBooleanToggleButtonGroup } from "shared/components/button/ToggleButton";
import {
  ContentBlock,
  ContentBlockBody,
  ContentBlockHeader,
  ContentBlockTitle,
} from "shared/components/content/ContentBlock";
import { FormMoneyInput } from "shared/components/input/text/MoneyInput";

interface FeeFormSectionCatchUpInterestProps {
  control: Control<
    FeeCreateAPIDataRequest & {
      fee_eligible_for_true_up: boolean;
    }
  >;
  isDisabled?: boolean;
}

const ManagementFeeCatchUpInterestOnExisting: React.FC<{
  isDisabled?: boolean;
}> = ({ isDisabled }) => {
  const { t } = useTranslation(["fees"]);
  return (
    <FormBooleanToggleButtonGroup
      name="fee.interest_charged_to_existing_commitments"
      title={t("fees:chargeInterestToExistingCommitments")}
      isDisabled={isDisabled}
    />
  );
};

const CatchUpMaterialityThreshold: React.FC<{
  isDisabled?: boolean;
}> = ({ isDisabled }) => {
  const { t } = useTranslation(["fees"]);
  return (
    <FormMoneyInput
      name="fee.catch_up_materiality_threshold"
      title={t("fees:catchUpMaterialityThreshold")}
      isDisabled={isDisabled}
    />
  );
};

const FeeFormSectionCatchUpInterest: React.FC<
  FeeFormSectionCatchUpInterestProps
> = ({ isDisabled }) => {
  const { t } = useTranslation(["fees"]);
  return (
    <ContentBlock>
      <ContentBlockHeader>
        <ContentBlockTitle>
          {t("fees:feeForm.managementFeeInterest")}
        </ContentBlockTitle>
      </ContentBlockHeader>
      <ContentBlockBody variant="form">
        <ManagementFeeCatchUpInterestOnExisting isDisabled={isDisabled} />
        <CatchUpMaterialityThreshold isDisabled={isDisabled} />
      </ContentBlockBody>
    </ContentBlock>
  );
};

export default FeeFormSectionCatchUpInterest;
